import { Pipe, PipeTransform } from '@angular/core';
import format from 'date-fns/format';
import { parsedOutput } from '../helper-functions';
import { DatePipeManager } from '../providers/date-pipe-manager';
export class DatePipe implements PipeTransform {
/**
 * Input can be a string, number or Date
 * Pipe returns the output of the date-fns format function
 * @param {?} manager
 */
constructor(private manager: DatePipeManager) {}
/**
 * @param {?} value
 * @param {?=} dateFormat
 * @return {?}
 */
transform(value: string | number | Date, dateFormat?: string) {
    const /** @type {?} */ formatToUse = this.manager.getDefaultFormat(dateFormat);
    // const options = { locale: this.manager.getDefaultLocale() };
    return format(value, formatToUse);
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{
  name: 'date',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: DatePipeManager, },
];
}

function DatePipe_tsickle_Closure_declarations() {
/** @type {?} */
DatePipe.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DatePipe.ctorParameters;
/** @type {?} */
DatePipe.prototype.manager;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
